export const REQUIRED_2FA_ERROR_CODE = 422;
